var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2","data-name":"Path 2","d":"M-699.081,368.6v-1.192a.624.624,0,0,1,.653-.709h1.667v-2.545h-2.3a2.887,2.887,0,0,0-3.125,3.109V368.6h-1.482v2.972h1.5V379h2.972v-7.426h2.2l.1-1.168.177-1.8Z","transform":"translate(703.664 -364.153)","fill":"#293d43","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"6.943","height":"14.844","viewBox":"0 0 6.943 14.844"};

module.exports = Facebook;

Facebook.default = Facebook;
